import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";
import { getCachedScript } from "../../utils/scriptCache.js";
import "./EaseAnimator.css";

function EaseAnimator({ selectedTag, buttonTags, generateButtonTags }) {
  const [isVisible, setIsVisible] = useVisible("EaseAnimatorGroupVisibility");
  const [easeType, setEaseType] = useVisible("EaseAnimatorType", "in");
  const [animatorData, setEaseAnimatorData] = useVisible(
    "setEaseAnimatorData"
  );
  const easeModeIcons = {
    in: "<",
    "in-out": "< - >",
    out: ">",
  };

  const getEaseArguments = (type, properties, extraArguments = {}) => {
    return {
      type,
      ...(properties ? { properties } : {}),
      ...extraArguments,
    };
  };

  const handleEaseAnimator = (properties, extraArguments) => {
    if (easeType === "in-out") {
      handleClick(
        "easeAnimator",
        getEaseArguments("in", properties, extraArguments)
      );
      handleClick(
        "easeAnimator",
        getEaseArguments("out", properties, extraArguments)
      );
      return false;
    }

    handleClick(
      "easeAnimator",
      getEaseArguments(easeType, properties, extraArguments)
    );
    return false;
  };

  const handleCopy = () => {
    const code = getCachedScript();
    if (!code) {
      return false;
    }

    window.jsx.evalScript("run(saveEaseAnimatorPreset());", function (result) {
      if (result && result !== "undefined" && result !== "false") {
        setEaseAnimatorData(result);
      }
    });

    return false;
  };

  const handlePaste = () => {
    const code = getCachedScript();
    if (!code || !animatorData) {
      return false;
    }

    const presetsJson =
      typeof animatorData === "string"
        ? animatorData
        : JSON.stringify(animatorData);

    window.jsx.evalScript(
      `(function() {
        var presets = JSON.parse(${JSON.stringify(presetsJson)});
        for (var i = 0; i < presets.length; i++) {
          run(easeAnimator(presets[i]));
        }
      })();`,
      function () {}
    );

    return false;
  };

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i className="fa-light fa-arrows-up-down-left-right"></i>
          <div />
        </div>
        <div className="button-card__title">Ease Animator</div>
        {generateButtonTags()}
      </li>
      <div className={`resolution-tools ${isVisible ? "" : "hidden"}`}>
        <div className="ease-animator__mode">
          {["in", "in-out", "out"].map((type) => (
            <div
              key={type}
              onClick={() => setEaseType(type)}
              className={`resolution-tools__button ease-animator__mode-button ${
                easeType === type ? "active" : ""
              }`}
              title={type}
              aria-label={type}
            >
              <span>{easeModeIcons[type]}</span>
            </div>
          ))}
        </div>
        <div
          onClick={() => handleEaseAnimator()}
          className="resolution-tools__button"
        >
          <i className="fa-solid fa-arrow-pointer"></i>
          <span>Selected Properties</span>
        </div>
        <div
          onClick={() =>
            handleEaseAnimator(["position", "scale", "rotation", "opacity"])
          }
          className="resolution-tools__button"
        >
          <i className="fa-light fa-layer-group"></i>
          <span>All Transform</span>
        </div>
        <div
          onClick={() => handleEaseAnimator(["position"])}
          className="resolution-tools__button"
        >
          <i className="fa-light fa-arrows-up-down-left-right"></i>
          <span>Position</span>
        </div>
        <div
          onClick={() => handleEaseAnimator(["scale"])}
          className="resolution-tools__button"
        >
          <i className="fa-sharp fa-light fa-arrows-maximize"></i>
          <span>Scale</span>
        </div>
        <div
          onClick={() => handleEaseAnimator(["rotation"])}
          className="resolution-tools__button"
        >
          <i className="fa-solid fa-rotate-right"></i>
          <span>Rotation</span>
        </div>
        <div
          onClick={() => handleEaseAnimator(["opacity"])}
          className="resolution-tools__button"
        >
          <i className="fa-regular fa-circle-half-stroke"></i>
          <span>Opacity</span>
        </div>
        <div
          onClick={() =>
            handleEaseAnimator({
              positionShift: {
                direction: "Bottom",
              },
            })
          }
          className="resolution-tools__button"
        >
          <i className="fa-light fa-swap-arrows"></i>
          <span>Position Shift</span>
        </div>
        <div onClick={handleCopy} className="resolution-tools__button">
          <i className="fa-regular fa-copy"></i>
          <span>Copy</span>
        </div>
        <div onClick={handlePaste} className="resolution-tools__button">
          <i className="fa-light fa-paste"></i>
          <span>Paste</span>
        </div>
        <div
          onClick={() => handleClick("deleteEaseAnimator", false)}
          className="resolution-tools__button"
        >
          <i className="fa-light fa-trash"></i>
          <span>Delete</span>
        </div>
      </div>
    </>
  );
}

export default EaseAnimator;
